import React, {useEffect} from 'react';
import TopNav from "../../Component/NavBar/TopNav";
import SideBarAndContentWrapper from "../../Component/Wrapper/SideBarAndContentWrapper";
import SideBar from "../../Component/NavBar/SideBar";
import ContentWrapper from "../../Component/Wrapper/ContentWrapper";
import Auth from "../../Utilities/Auth";
import {useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import SideNavUtilities from "../../Component/NavBar/Utilities/SideNavUtilities";
import {Container} from "react-bootstrap";

function ProtectedRoute(props) {
    const {permissions = ["*"]} = props
    // hooks
    const navigate = useNavigate()
    const location = useLocation()
    let auth = Auth.header()
    const isLogged = useSelector(state => state.authSlice.isLogged)
    const isPermitted = new SideNavUtilities().isPermitted([...permissions])
    const sessionIsChanged = useSelector(state => state.authSlice.sessionIsChanged)


    // auth check lifecycle
    useEffect(() => {
        if (auth == false && isLogged == false) {
            Auth.clear()
            navigate("/login")
        }
    }, [location, isLogged])

    // is permitted page or not check lifecycle
    useEffect(() => {
        if (isPermitted == false) {
            navigate("/dashboard")
        }
    }, [location, isPermitted, sessionIsChanged])


    // check user logged in or not
    if (auth != false) {
        return (
            <>
                <TopNav/>
                {/*side bar and content wrapper*/}
                <SideBarAndContentWrapper>
                    <SideBar/>
                    {/*only content wreapper*/}
                    <ContentWrapper>
                        <Container className="mt-4" fluid={true}>
                            {/*check permitted or not*/}
                            {isPermitted == true && props.children}
                        </Container>
                    </ContentWrapper>
                </SideBarAndContentWrapper>
            </>
        );
    } else {
        return <></>
    }

}

export default ProtectedRoute;